import script from "./FormItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FormItem.vue?vue&type=script&setup=true&lang=js"

import "./FormItem.vue?vue&type=style&index=0&id=172e84f2&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-172e84f2"]])

export default __exports__